export class SubjectTypes {
  public static readonly MATH = "MATH";
  public static readonly READING = "READING";
  public static readonly NONE = "NONE";
}
